import { createProjectionChangesInput } from '@databases/selections';
import { type DatabaseAdapter } from '@databases/selections-api-types';

import {
  SelectionFeatureKeys,
  type SelectionInputFeature,
  type SelectionViewChanges,
} from '../../features/types.ts';

export function createProjectionChangesInputFeature({
  databaseAdapter,
  viewChanges,
}: {
  databaseAdapter: DatabaseAdapter;
  viewChanges: SelectionViewChanges;
}): SelectionInputFeature {
  return {
    key: SelectionFeatureKeys.PROJECTION_CHANGES_INPUT,
    type: 'input',
    factory: (machine) =>
      createProjectionChangesInput(machine, databaseAdapter, {
        subscribe: viewChanges.subscribe,
        isProjectionAvailable: viewChanges.isAvailable,
      }),
  };
}
